import { useEffect, useRef } from 'react';
import CircleCheckBig from 'lucide-react/dist/esm/icons/circle-check-big.mjs';
import FingerprintPattern from 'lucide-react/dist/esm/icons/fingerprint-pattern.mjs';
import TriangleAlert from 'lucide-react/dist/esm/icons/triangle-alert.mjs';

function Modal({ open, onClose, children, labelledBy, tone = 'default' }) {
  const dialogRef = useRef(null);

  useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog) {
      return;
    }

    if (open && !dialog.open) {
      dialog.showModal();
    } else if (!open && dialog.open) {
      dialog.close();
    }
  }, [open]);

  return (
    <dialog
      ref={dialogRef}
      className={`modal modal--${tone}`}
      aria-labelledby={labelledBy}
      onCancel={(event) => {
        event.preventDefault();
        onClose();
      }}
      onClick={(event) => {
        if (event.target === event.currentTarget) {
          onClose();
        }
      }}
    >
      {children}
    </dialog>
  );
}

export function SuccessDialog({ dialog, onClose, onDeactivate, busy }) {
  const subscription = dialog?.type === 'success' ? dialog.subscription : null;

  return (
    <Modal
      open={Boolean(subscription)}
      onClose={onClose}
      labelledBy="success-title"
      tone="success"
    >
      <div className="modal__content success-content">
        <div className="success-orb" aria-hidden="true">
          <img src="/assets/bolt-protect-orb.webp" alt="" />
          <CircleCheckBig className="success-orb__check" />
        </div>
        <h2 id="success-title">Защита подключена</h2>
        <p>Подписка подтверждена на этом устройстве.</p>

        <div className="subscription-summary">
          <div className="subscription-summary__status">
            <span className="status-shield" aria-hidden="true">
              <CircleCheckBig />
            </span>
            <strong>Активна</strong>
            <span aria-hidden="true">·</span>
            <strong className="accent-text">20 ₽/день</strong>
          </div>
          <span>Следующее продление — завтра</span>
        </div>

        <button className="modal__primary" type="button" onClick={onClose}>
          Готово
        </button>
        <button
          className="modal__secondary"
          type="button"
          onClick={onDeactivate}
          disabled={busy}
        >
          {busy ? 'Отключаем…' : 'Отключить демо‑подписку'}
        </button>

        <div className="modal__audit">
          <FingerprintPattern aria-hidden="true" />
          <span>Подтверждено с помощью passkey</span>
        </div>
      </div>
    </Modal>
  );
}

export function ErrorDialog({ dialog, onClose }) {
  const error = dialog?.type === 'error' ? dialog : null;

  return (
    <Modal open={Boolean(error)} onClose={onClose} labelledBy="error-title" tone="error">
      <div className="modal__content error-content">
        <div className="error-icon" aria-hidden="true">
          <TriangleAlert />
        </div>
        <h2 id="error-title">Подписка не подключена</h2>
        <p>{error?.message}</p>
        <button className="modal__primary" type="button" onClick={onClose}>
          Понятно
        </button>
        <span className="error-content__safety">Списаний и изменений не произошло</span>
      </div>
    </Modal>
  );
}
